import { conhecerOErp } from './primeiros-passos';
import { entradaNotaFiscal, entradaPlanilha } from './entrada';
import {
  cadastrarEquipamento,
  consultarPatrimonios,
  editarERegistrarEnvio,
  movimentarEquipamentos,
  verOEstoque,
} from './patrimonio';
import { auditoriaMensal, historicoDoPatrimonio, marcaModeloEGrupos } from './expedicao';

/**
 * As etapas da página de tutoriais, na ordem do Manual do Assistente de
 * Expedição: conhecer o ERP, dar entrada, cuidar do patrimônio e expedir.
 */
export const TRILHA = [
  { id: 'primeiros-passos', nome: 'Primeiros passos', tutoriais: [conhecerOErp] },
  { id: 'entrada', nome: 'Entrada no estoque', tutoriais: [entradaNotaFiscal, entradaPlanilha] },
  {
    id: 'patrimonio',
    nome: 'Patrimônio',
    tutoriais: [
      cadastrarEquipamento,
      consultarPatrimonios,
      movimentarEquipamentos,
      editarERegistrarEnvio,
      verOEstoque,
    ],
  },
  {
    id: 'expedicao',
    nome: 'Expedição e auditoria',
    tutoriais: [historicoDoPatrimonio, marcaModeloEGrupos, auditoriaMensal],
  },
];

export const TUTORIAIS = TRILHA.flatMap((etapa) => etapa.tutoriais);

export const obterTutorial = (id) => TUTORIAIS.find((tutorial) => tutorial.id === id) ?? null;

/**
 * Tutorial ou passo marcado `exigeAdmin` ensina tela que só o nível Admin (3)
 * tem: o menu Entrada e as abas Marca/Modelo e Grupos. Para os outros níveis
 * o tutorial fica trancado e o passo sai do tutorial.
 */
export const disponivelPara = (item, isAdmin) => !item.exigeAdmin || !!isAdmin;

export const passosPara = (tutorial, isAdmin) =>
  tutorial.passos.filter((passo) => disponivelPara(passo, isAdmin));

/** O próximo da trilha depois de `id`, disponível e ainda não concluído, voltando ao começo se preciso. */
export const proximoTutorial = (id, concluidos, isAdmin) => {
  const indice = TUTORIAIS.findIndex((tutorial) => tutorial.id === id);
  const depois = [...TUTORIAIS.slice(indice + 1), ...TUTORIAIS.slice(0, Math.max(indice, 0))];
  return (
    depois.find(
      (tutorial) =>
        tutorial.id !== id && disponivelPara(tutorial, isAdmin) && !concluidos.includes(tutorial.id)
    ) ?? null
  );
};
